<template>
  <div class="ui grid" v-if="test">
    <div class="row">
      <h1 class="ui huge header">{{ $t('welcomeTitle') }}</h1>
    </div>
    <div class="ui divider"></div>
    <div class="row">
      <p>
        {{ $t('welcomeText') }}
      </p>
    </div>
    <div class="row" v-if="!test.expired">
      <div class="ui divided items">
        <div class="item">
          <div class="image">
            <router-link to="/student/select">
              <i class="massive arrow circle right icon"></i>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-else>
      <p class="ui negative message">
        {{ $t('testExpired') }}
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Home',
  components: {},
  computed: mapGetters({
    test: 'test',
  }),
  data() {
    return {};
  },
  methods: {},
  async created() {
    await this.$store.dispatch('getTest', this.$route.params.code);
    this.$store.dispatch('setLanguage', this.test.defaultLanguage);
    this.$i18n.locale = this.test.defaultLanguage;
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Home.vue